import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=40e152ba&scoped=true"
import script from "./BasicSettings.vue?vue&type=script&lang=js"
export * from "./BasicSettings.vue?vue&type=script&lang=js"
import style0 from "./BasicSettings.vue?vue&type=style&index=0&id=40e152ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e152ba",
  null
  
)

export default component.exports